<form [formGroup]="form" novalidate class="flex flex-column">
    <div class="grid">

        @if (appService.selectedClient?.demo) {
        <!-- Réinitialisation des données de la société -->
        <div class="col-12 p-3 flex justify-content-between align-items-center">
            <div>
                <div class="text-lg font-semibold mb-2">Réinitialiser la société</div>
                <div>Supprimer toutes les données de la société et revenir à l'état initial de sa création. Cette action
                    est
                    définitive et irréversible, soyez sûr de vous.</div>
            </div>
            <div>
                <p-button label="Réinitialiser les données" severity="danger" [rounded]="true"
                    (onClick)="onClickReset()"></p-button>
            </div>
        </div>

        } @else {

        <!-- Suppression de la société -->
        <div class="col-12 p-3 flex justify-content-between align-items-center">
            <div>
                <div class="text-lg font-semibold mb-2">Supprimer la société</div>
                <div>Supprimer définitivement la société et toutes ses données.<br/>Cette action est définitive et
                    irréversible,
                    soyez sûr de vous.</div>
            </div>
            @if (isOwner) {
            <div>
                <p-button label="Supprimer la société" severity="danger" [rounded]="true"
                    (onClick)="onClickDelete()"></p-button>
            </div>
            }
        </div>
        @if (!isOwner) {
        <!-- Information : seul le propriétaire peut supprimer -->
        <div class="col-12 p-3">
            <p-message severity="secondary" icon="pi pi-info-circle" styleClass="w-full">Seul le propriétaire de la
                société ({{appService.selectedClient?.owner?.fullName}}) peut la supprimer.</p-message>
        </div>
        }
        <!-- Validation -->
        @if (isOwner && showDeleteValidation) {
        <div class="col-12 p-3 flex justify-content-between align-items-center">
            <div>
                <div class="font-semibold mb-2">Saisissez le texte ci-dessous pour valider</div>
                <input pInputText type="text" formControlName="deletePhrase"
                    placeholder="Supprimer définitivement {{appService.selectedClient?.commercialName}}">
            </div>
            <div>
                <p-button class="mr-3" label="Annuler" [outlined]="true" [rounded]="true"
                    (onClick)="onClickCancel()"></p-button>
                <p-button label="Valider la suppression" severity="danger" [rounded]="true"
                    (onClick)="onClickValidateDelete()" [disabled]="isDeleteButtonDisabled"></p-button>
            </div>
        </div>
        }
        }

    </div>
</form>